import { Box, Button, Typography } from '@mui/material';
import { Link } from 'components/common/Link';

import { useServerTranslation } from 'hooks/useServerTranslation';
import EmailPasswordInput from './EmailPasswordInput';

type UserLoginFormProps = {
    openForgotPassword?: () => void;
};

export default function UserLoginForm({ openForgotPassword }: UserLoginFormProps) {
    const { t } = useServerTranslation();

    return (
        <>
            <Typography variant="h2" paddingBottom={2}>
                {t('user.login-as-user')}
            </Typography>
            <Box
                display="grid"
                gridTemplateColumns="1fr"
                columnGap={4}
            >
                <EmailPasswordInput />
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Button variant="text" size="small" onClick={openForgotPassword}>
                    {t('user.forgot-password')}
                </Button>
                <Button
                    type="submit"
                    data-testid="user-login-button"
                >
                    {t('menu.log-in')}
                </Button>
            </Box>
            <Box paddingBottom={2}>
                <Button
                    variant="text"
                    size="small"
                    LinkComponent={Link}
                    href="/findconsultant"
                    data-testid="find-consultant-submit"
                >
                    {t('user.new-user')}
                </Button>
            </Box>
        </>
    );
}
